import { render, staticRenderFns } from "./OperaApplicationInfoWindow.vue?vue&type=template&id=99c5bea6&"
import script from "./OperaApplicationInfoWindow.vue?vue&type=script&lang=js&"
export * from "./OperaApplicationInfoWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports